import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";
import Projects1 from "./Projects1";
import { Commitment } from "./Commitment";
import AdvanceHMIVideo from "./AdvanceHMIVideo";
import Innovation from "./Innovation";
import { ContactUs } from "./ContactUs";
import QualitySection from "./QualitySection";
import WhyChoose from "./WhyChoose";
import AiAutomationProcess from "./AiAutomation";
import FarmGallery from "./Sustainability";
import BrandCarousel from "./BrandCarosel";
import Cultivate from "./Cultivate";
import Hydroponics from "./Hydroponics";

export default function HomeMain() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Hero />
      <QualitySection />
      <section id="automation">
      </section>
      <Projects1 />
      <section id="commitment">
        <Commitment />
      </section>
      <AiAutomationProcess />
      <WhyChoose />
      <AdvanceHMIVideo />
      <BrandCarousel />
            <Hydroponics />

      <Innovation />
      <Cultivate />
      <FarmGallery />
      <section id="contact">
        <ContactUs />
      </section>
    </>
  );
}
